
const url_base = 'https://api.pay.monitorlatino.com/';


export const getChart = async (pais: any, formato: any) => {
    const url = url_base + `playlist/api/Chart/getChartbyCountry/${ pais }/${ formato }/`;
    console.log("FETCHING..");
    //audio = await fetch(url, { mode: 'cors' }).then(response => response.text()).then( t => t);
    let chart = await fetch(url, {
        method: 'GET', headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
        },
    })
        .then(response => response.json())
        .then( json => json.map( (p: any) => ({
            cs_song: p.cs_song,
            title: p.title,
            artists: p.artists,
            rank: p.rank,
            img: p.img_portada_min,
            flag: p.country_flag,
            url: p.url_chart,
            arrow: p.arrow,
            rcolor: p.color,
            errorimg: p.img_artistas,
        })));

    return chart;
}

export const getFormats= async (pais: any, format: any) => {
    const url = url_base + `playlist/api/Chart/getFormatbyCountry/${ pais }/${ format }`;
    console.log("FETCHING..");
    //audio = await fetch(url, { mode: 'cors' }).then(response => response.text()).then( t => t);
    let chart = await fetch(url, {
        method: 'GET', headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
        },
    })
        .then(response => response.json())
        .then( json => json.map( (p: any) => ({
            id: p.id,
            format: p.format,
            h_color: p.highcolor,
            l_color: p.lowcolor,
            countryname: p.country_name,
            flag: p.country_flag,
            css: p.css,
            url: p.url_chart
        })));

    return chart;
}